import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { error, updateStepData, saveBillingInfo } from '../SubscribeActions';
import BillingInfoForm from './BillingInfoForm';

// Import Style
import '../Subscribe.scss';

class BillingInfo extends Component {
  static defaultProps = {
    onNext: function () {},
    onBack: function () {},
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };

    this.handleNextClick = this.handleNextClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleNextClick() {
    if (this.validate()) {
      this.setState({ loading: true });
      this.props
        .saveBillingInfo(this.props.model)
        .then(() => {
          this.props.onNext();
        })
        .catch((err) => {
          this.setState({ loading: false });
        });
    }
  }

  validate() {
    if (!this.props.model.firstName) {
      this.props.setError('First name is required');
      return false;
    }
    if (!this.props.model.lastName) {
      this.props.setError('Last name is required');
      return false;
    }
    if (!this.props.model.country) {
      this.props.setError('Country is required');
      return false;
    }
    if (!this.props.model.city) {
      this.props.setError('City is required');
      return false;
    }
    if (!this.props.model.address) {
      this.props.setError('Address is required');
      return false;
    }
    if (this.props.model.address.length > 50) {
      this.props.setError('Address must be less than 50 characters');
      return false;
    }
    if (!this.props.model.billingEmails) {
      this.props.setError('Billing email is required');
      return false;
    }

    return true;
  }

  handleChange(model) {
    this.props.updateStepData(model);
  }

  render() {
    const { model } = this.props;

    return (
      <div className='billing_inner_content'>
        <BillingInfoForm model={model} onChange={this.handleChange}></BillingInfoForm>
        <div className='action_box_billing'>
          <Button variant='secondary' className='btn_prev' onClick={this.props.onBack}>
            Back
          </Button>
          <Button variant='primary' className='btn_next' onClick={this.handleNextClick}>
            {this.state.loading ? 'Loading...' : 'Next'}
          </Button>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (err) => dispatch(error(err)),
    saveBillingInfo: (model) => dispatch(saveBillingInfo(model)),
    updateStepData: (model) => dispatch(updateStepData(model)),
  };
};

const mapStateToProps = (state) => {
  return {
    model: state.subscription.model,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingInfo);
